module.exports = __webpack_public_path__ + "static/media/home-header-img.870289f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-header-img.png
// module id = 294
// module chunks = 0